/**
 * Fitnesspilot
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the Lunchtime interface.
 */
export function instanceOfLunchtime(value) {
    if (!("within" in value) || value.within === undefined)
        return false;
    return true;
}
export function LunchtimeFromJSON(json) {
    return LunchtimeFromJSONTyped(json, false);
}
export function LunchtimeFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        duration: json.duration == null ? undefined : json.duration,
        within: json.within,
    };
}
export function LunchtimeToJSON(value) {
    if (value == null) {
        return value;
    }
    return {
        duration: value.duration,
        within: value.within,
    };
}
